<template>
  <div :class="device.desktop ? `appinfo pa-6` : `appinfo pa-2`">
    <v-row dense>
      <!-- ===== Panel pratinjau ===== -->
      <v-col
        :cols="device.desktop ? 4 : 12"
        class="d-flex"
      >
        <div class="ai-panel flex-grow-1">
          <div class="ai-panel-header">
            <v-icon
              small
              color="#60a5fa"
              class="mr-2"
            >mdi-monitor-cellphone</v-icon>
            <span class="ai-panel-title">PRATINJAU APLIKASI</span>
          </div>

          <div class="ai-preview">
            <v-hover>
              <template v-slot:default="{ hover }">
                <div
                  class="ai-logo-wrap"
                  :class="hover ? `ai-logo-wrap--hover` : ``"
                >
                  <v-img
                    :src="foto"
                    contain
                    height="96"
                    width="96"
                  ></v-img>
                  <div
                    class="ai-logo-overlay"
                    v-show="hover"
                  >
                    <v-btn
                      icon
                      dark
                      small
                      @click="uploadFoto"
                    >
                      <v-icon small>mdi-camera</v-icon>
                    </v-btn>
                  </div>
                </div>
              </template>
            </v-hover>

            <div class="ai-preview-name">{{ record.app_name || "Nama Aplikasi" }}</div>
            <div class="ai-preview-slogan">{{ record.app_slogan || "Slogan aplikasi anda" }}</div>
            <div class="ai-preview-chip">
              <v-icon
                x-small
                color="#93c5fd"
              >mdi-tag-outline</v-icon>
              <span>Versi {{ record.app_ver || "-" }}</span>
            </div>
          </div>

          <div class="ai-divider"></div>

          <div class="ai-info-list">
            <div class="ai-info-item">
              <v-icon
                small
                color="#60a5fa"
              >mdi-domain</v-icon>
              <div>
                <div class="ai-info-label">Instansi</div>
                <div class="ai-info-value">{{ record.app_company || "-" }}</div>
              </div>
            </div>
            <div class="ai-info-item">
              <v-icon
                small
                color="#60a5fa"
              >mdi-web</v-icon>
              <div>
                <div class="ai-info-label">Alamat Url</div>
                <div class="ai-info-value">{{ record.app_url || "-" }}</div>
              </div>
            </div>
            <div class="ai-info-item">
              <v-icon
                small
                color="#60a5fa"
              >mdi-whatsapp</v-icon>
              <div>
                <div class="ai-info-label">Telpon / WhatsApp</div>
                <div class="ai-info-value">{{ record.app_wa || "-" }}</div>
              </div>
            </div>
            <div class="ai-info-item">
              <v-icon
                small
                color="#60a5fa"
              >mdi-map-marker-outline</v-icon>
              <div>
                <div class="ai-info-label">Alamat</div>
                <div class="ai-info-value">{{ record.app_address || "-" }}</div>
              </div>
            </div>
          </div>

          <div class="ai-divider"></div>

          <div class="ai-assets">
            <div class="ai-asset">
              <div class="ai-asset-label">
                <v-icon
                  x-small
                  color="#94a3b8"
                >mdi-image-outline</v-icon>
                Background
              </div>
              <v-hover>
                <template v-slot:default="{ hover }">
                  <div class="ai-asset-img-wrap">
                    <v-img
                      :src="bg"
                      height="80"
                      class="ai-asset-img"
                    ></v-img>
                    <div
                      class="ai-logo-overlay"
                      v-show="hover"
                    >
                      <v-btn
                        icon
                        dark
                        small
                        @click="editBackground"
                      >
                        <v-icon small>mdi-camera</v-icon>
                      </v-btn>
                    </div>
                  </div>
                </template>
              </v-hover>
            </div>
            <div class="ai-asset">
              <div class="ai-asset-label">
                <v-icon
                  x-small
                  color="#94a3b8"
                >mdi-page-layout-sidebar-left</v-icon>
                Sidebar
              </div>
              <v-hover>
                <template v-slot:default="{ hover }">
                  <div class="ai-asset-img-wrap">
                    <v-img
                      :src="bg_nav"
                      height="80"
                      class="ai-asset-img"
                    ></v-img>
                    <div
                      class="ai-logo-overlay"
                      v-show="hover"
                    >
                      <v-btn
                        icon
                        dark
                        small
                        @click="editSidebar"
                      >
                        <v-icon small>mdi-camera</v-icon>
                      </v-btn>
                    </div>
                  </div>
                </template>
              </v-hover>
            </div>
          </div>
        </div>
      </v-col>

      <!-- ===== Panel form ===== -->
      <v-col
        :cols="device.desktop ? 8 : 12"
        class="d-flex"
      >
        <div class="ai-panel flex-grow-1">
          <div class="ai-panel-header">
            <v-icon
              small
              color="#60a5fa"
              class="mr-2"
            >mdi-cog-outline</v-icon>
            <span class="ai-panel-title">KONFIGURASI INFORMASI APLIKASI</span>
          </div>

          <div class="ai-form">
            <!-- Informasi umum -->
            <div class="ai-section-title">
              <v-icon
                small
                color="#93c5fd"
              >mdi-information-outline</v-icon>
              Informasi Umum
            </div>
            <v-row dense>
              <v-col :cols="device.desktop ? 8 : 12">
                <v-text-field
                  label="Nama Aplikasi"
                  v-model="record.app_name"
                  dark
                  dense
                  outlined
                  color="#60a5fa"
                  background-color="#0a1224"
                  persistent-hint
                  hint="Nama yang tampil pada sidebar dan judul aplikasi"
                  prepend-inner-icon="mdi-application-outline"
                ></v-text-field>
              </v-col>
              <v-col :cols="device.desktop ? 4 : 12">
                <v-text-field
                  label="Versi"
                  v-model="record.app_ver"
                  dark
                  dense
                  outlined
                  color="#60a5fa"
                  background-color="#0a1224"
                  persistent-hint
                  hint="Contoh: 1.0"
                  prepend-inner-icon="mdi-tag-outline"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  label="Keterangan"
                  v-model="record.app_desc"
                  dark
                  dense
                  outlined
                  color="#60a5fa"
                  background-color="#0a1224"
                  persistent-hint
                  hint="Deskripsi singkat tentang fungsi aplikasi"
                  prepend-inner-icon="mdi-text-box-outline"
                ></v-text-field>
              </v-col>
            </v-row>

            <!-- Tampilan -->
            <div class="ai-section-title">
              <v-icon
                small
                color="#93c5fd"
              >mdi-palette-outline</v-icon>
              Tampilan
            </div>
            <v-row dense>
              <v-col :cols="device.desktop ? 6 : 12">
                <v-select
                  label="Tema"
                  v-model="record.app_theme"
                  :items="themes"
                  dark
                  dense
                  outlined
                  color="#60a5fa"
                  background-color="#0a1224"
                  persistent-hint
                  hint="Mode terang atau gelap untuk halaman backend"
                  prepend-inner-icon="mdi-theme-light-dark"
                ></v-select>
              </v-col>
              <v-col :cols="device.desktop ? 6 : 12">
                <v-select
                  label="Warna"
                  v-model="record.app_color"
                  :items="colors"
                  dark
                  dense
                  outlined
                  color="#60a5fa"
                  background-color="#0a1224"
                  persistent-hint
                  hint="Warna aksen tombol dan komponen aplikasi"
                  prepend-inner-icon="mdi-format-color-fill"
                ></v-select>
              </v-col>
            </v-row>

            <!-- Instansi & kontak -->
            <div class="ai-section-title">
              <v-icon
                small
                color="#93c5fd"
              >mdi-domain</v-icon>
              Instansi &amp; Kontak
            </div>
            <v-row dense>
              <v-col :cols="device.desktop ? 6 : 12">
                <v-text-field
                  label="Nama Instansi"
                  v-model="record.app_company"
                  dark
                  dense
                  outlined
                  color="#60a5fa"
                  background-color="#0a1224"
                  persistent-hint
                  hint="Nama instansi pemilik aplikasi"
                  prepend-inner-icon="mdi-office-building-outline"
                ></v-text-field>
              </v-col>
              <v-col :cols="device.desktop ? 6 : 12">
                <v-text-field
                  label="Slogan"
                  v-model="record.app_slogan"
                  dark
                  dense
                  outlined
                  color="#60a5fa"
                  background-color="#0a1224"
                  persistent-hint
                  hint="Slogan atau tagline instansi"
                  prepend-inner-icon="mdi-format-quote-close"
                ></v-text-field>
              </v-col>
              <v-col :cols="device.desktop ? 6 : 12">
                <v-text-field
                  label="Url"
                  v-model="record.app_url"
                  dark
                  dense
                  outlined
                  color="#60a5fa"
                  background-color="#0a1224"
                  persistent-hint
                  hint="Alamat website aplikasi, contoh: https://cctv.tangerangkab.go.id"
                  prepend-inner-icon="mdi-web"
                ></v-text-field>
              </v-col>
              <v-col :cols="device.desktop ? 6 : 12">
                <v-text-field
                  label="Telpon/Whatsapp"
                  v-model="record.app_wa"
                  dark
                  dense
                  outlined
                  color="#60a5fa"
                  background-color="#0a1224"
                  persistent-hint
                  hint="Nomor yang dapat dihubungi masyarakat"
                  prepend-inner-icon="mdi-whatsapp"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-textarea
                  label="Alamat"
                  v-model="record.app_address"
                  dark
                  dense
                  outlined
                  color="#60a5fa"
                  background-color="#0a1224"
                  persistent-hint
                  hint="Alamat lengkap kantor instansi"
                  prepend-inner-icon="mdi-map-marker-outline"
                  rows="3"
                ></v-textarea>
              </v-col>
            </v-row>

            <div class="ai-form-footer">
              <div class="ai-form-note">
                <v-icon
                  x-small
                  color="#94a3b8"
                >mdi-information-outline</v-icon>
                Perubahan akan diterapkan ke seluruh aplikasi setelah disimpan
              </div>
              <v-spacer></v-spacer>
              <v-btn
                depressed
                dark
                class="ai-btn-save"
                @click="fetchUpdate"
              >
                <v-icon
                  left
                  small
                >mdi-content-save-outline</v-icon>
                Simpan
              </v-btn>
            </div>
          </div>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
export default {
  name: "app-info",
  data: () => ({
    dialog: false,
    foto: "/",
    bg: "/",
    bg_nav: "/image/bg-nav.jpep",
    provinsis: [],
    kabupatens: [],
    kecamatans: [],
    desas: [],
    record: {
      tanggal_mulai: null,
      tanggal_selesai: null,
    },
    colors: [
      { value: "red", text: "Red" },
      { value: "pink", text: "Pink" },
      { value: "purple", text: "Purple" },
      { value: "deep purple", text: "Deep Pruple" },
      { value: "indigo", text: "Indigo" },
      { value: "light blue", text: "Light Blue" },
      { value: "cyan", text: "Cyan" },
      { value: "teal", text: "Teal" },
      { value: "green", text: "Green" },
      { value: "light green", text: "Light Green" },
      { value: "lemon", text: "Lemon" },
      { value: "yellow", text: "Yellow" },
      { value: "amber", text: "Amber" },
      { value: "orange", text: "Orange" },
      { value: "deep orange", text: "Deep Orange" },
      { value: "brown", text: "Brown" },
      { value: "blue grey", text: "Blue Grey" },
      { value: "grey", text: "Grey" },
    ],
    themes: [
      { value: "light", text: "Light" },
      { value: "dark", text: "Dark" },
    ],
    pesertas: [
      { value: 4, text: "Berkas Diterima" },
      { value: 2, text: "Berkas Diperbaiki" },
      { value: 3, text: "Berkas Pengajuan Diperbaiki" },
      { value: 5, text: "Berkas Ditolak" },
      { value: 6, text: "Berkas Dicabut" },
    ],
  }),

  computed: {
    ...mapState([
      "theme",
      "http",
      "device",
      "records",
      "loading",
      "event",
      "snackbar",
    ]),
  },
  created() {
    this.setPage({
      crud: true,
      dataUrl: "api/profil-sekolah",
      pagination: false,
      title: "INFORMASI APLIKASI",
      subtitle: "Berikut Data Infromasi Aplikasi Anda",
      breadcrumbs: [
        {
          text: "Master Data",
          disabled: false,
          href: "",
        },
        {
          text: "Informasi Aplikasi",
          disabled: false,
          href: "",
        },
      ],
    });
    this.fetchRecord();
  },
  mounted() {},
  methods: {
    ...mapActions([
      "setPage",
      "assignFileBrowse",
      "getUserInfo",
      "fetchRecords",
      "setTheme",
      "getAppInfo",
    ]),

    fetchRecord: async function () {
      let { data } = await this.http.get("api/superadmin/master-data/app-info");

      this.record = data;
      this.foto = data.app_logo_path;
      this.bg = data.app_background_path;
      this.bg_nav = data.app_nav_path;
      this.getAppInfo();
    },
    fetchUpdate: async function () {
      try {
        let {
          data: { status, message, data },
        } = await this.http.put(
          "api/superadmin/master-data/app-info/" + this.record.id,
          this.record
        );

        if (!status) {
          this.snackbar.color = "red";
          this.snackbar.text = message;
          this.snackbar.state = true;
          return;
        }

        this.snackbar.color = this.theme.color;
        this.snackbar.text = message;
        this.snackbar.state = true;

        this.record = data;
        this.fetchRecord();
        this.getUserInfo();
      } catch (error) {
        let messages = error.response.data.errors[0].message;
        this.snackbar.color = "red";
        this.snackbar.text = messages;
        this.snackbar.state = true;
      }
    },

    editBackground: function () {
      this.assignFileBrowse({
        fileType: [".jpg", ".jpeg", ".png"],
        query: {
          doctype: "apps",
        },
        callback: (response) => {
          this.bg = response.path;
          this.record.app_background = response.name;
        },
      });
    },

    editSidebar: function () {
      this.assignFileBrowse({
        fileType: [".jpg", ".jpeg", ".png"],
        query: {
          doctype: "apps",
        },
        callback: (response) => {
          this.bg_nav = response.path;
          this.record.app_nav = response.name;
        },
      });
    },

    uploadFoto: function () {
      this.assignFileBrowse({
        fileType: [".jpg", ".jpeg", ".png", ".svg"],
        query: {
          doctype: "apps",
        },
        callback: (response) => {
          setTimeout(() => {
            this.foto = response.path;
            this.record.app_logo = response.name;
          }, 1000);
        },
      });
    },
  },
};
</script>

<style scoped>
.appinfo {
  min-height: 100%;
  background: #0a1224;
}

/* ===== panel ===== */
.ai-panel {
  display: flex;
  flex-direction: column;
  background: #101b36;
  border: 1px solid #1e2c4f;
  border-radius: 12px;
  overflow: hidden;
  width: 100%;
}

.ai-panel-header {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  border-bottom: 1px solid #1e2c4f;
}

.ai-panel-title {
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.8px;
  color: #e2e8f0;
}

/* ===== pratinjau ===== */
.ai-preview {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 24px 16px 16px 16px;
}

.ai-logo-wrap {
  position: relative;
  padding: 12px;
  border-radius: 16px;
  background: #0a1224;
  border: 1px solid #1e2c4f;
  transition: border-color 0.2s ease;
}

.ai-logo-wrap--hover {
  border-color: #3b82f6;
}

.ai-logo-overlay {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(2, 6, 23, 0.55);
  border-radius: inherit;
}

.ai-preview-name {
  margin-top: 14px;
  font-size: 15px;
  font-weight: 700;
  color: #e2e8f0;
  text-align: center;
}

.ai-preview-slogan {
  margin-top: 2px;
  font-size: 11px;
  color: #94a3b8;
  text-align: center;
}

.ai-preview-chip {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  margin-top: 10px;
  padding: 3px 12px;
  border-radius: 999px;
  border: 1px solid #1e2c4f;
  background: #0a1224;
  font-size: 11px;
  font-weight: 600;
  color: #93c5fd;
}

.ai-divider {
  height: 1px;
  background: #1e2c4f;
  margin: 4px 16px;
}

/* ===== info list ===== */
.ai-info-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 14px 16px;
}

.ai-info-item {
  display: flex;
  gap: 12px;
  align-items: flex-start;
}

.ai-info-label {
  font-size: 10px;
  color: #94a3b8;
}

.ai-info-value {
  font-size: 12px;
  font-weight: 600;
  color: #e2e8f0;
  word-break: break-word;
}

/* ===== asset preview ===== */
.ai-assets {
  display: flex;
  gap: 10px;
  padding: 14px 16px 16px 16px;
}

.ai-asset {
  flex: 1;
}

.ai-asset-label {
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 10px;
  font-weight: 600;
  color: #94a3b8;
  margin-bottom: 6px;
}

.ai-asset-img-wrap {
  position: relative;
  border-radius: 10px;
  overflow: hidden;
  border: 1px solid #1e2c4f;
  background: #0a1224;
}

/* ===== form ===== */
.ai-form {
  padding: 8px 20px 20px 20px;
}

.ai-section-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  color: #93c5fd;
  margin: 18px 0 12px 0;
  padding-bottom: 8px;
  border-bottom: 1px dashed #1e2c4f;
}

.ai-form-footer {
  display: flex;
  align-items: center;
  margin-top: 20px;
  padding-top: 16px;
  border-top: 1px solid #1e2c4f;
}

.ai-form-note {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 11px;
  color: #94a3b8;
}

.ai-btn-save {
  border-radius: 10px;
  font-weight: 700;
  letter-spacing: 0.8px;
  background: linear-gradient(135deg, #1d4ed8 0%, #0b3a79 100%) !important;
  box-shadow: 0 8px 20px rgba(29, 78, 216, 0.35);
}
</style>
